import { render, staticRenderFns } from "./HtComments.vue?vue&type=template&id=312537e0&scoped=true&"
import script from "./HtComments.vue?vue&type=script&lang=js&"
export * from "./HtComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312537e0",
  null
  
)

export default component.exports